/**
 * Web: @react-native-masked-view/masked-view uses requireNativeComponent.
 * Stub keeps layout; shimmer may be less precise than native masking but avoids a crash.
 */
'use strict';

const React = require('react');
const { View } = require('react-native');

function MaskedView({ style, children, maskElement: _maskElement, ...rest }) {
  return React.createElement(View, { style, ...rest }, children);
}

module.exports = MaskedView;
module.exports.default = MaskedView;
